import { AppState, HeaderSettings } from '../types';

export const getHeadersState = (state: AppState) => state.headers;

export const getHeaders = (state: AppState, props: {name: string}): HeaderSettings[] => {
    const headersState = getHeadersState(state);
    return headersState && headersState.hasOwnProperty(props.name)
        ? headersState[props.name]
        : [];
};